// @flow
import * as Sentry from '@sentry/browser';

export default function clearSentryScope(): void {
  Sentry.configureScope(scope => scope.clear());
}
